import { ProviderContext } from "notistack";

let snackbarRef: ProviderContext;

export const setSnackbarRef = (ref: ProviderContext) => {
  snackbarRef = ref;
};

export const globalSnackbar = {
  enqueueSnackbar: (message: string, options?: any) => {
    if (snackbarRef) {
      snackbarRef.enqueueSnackbar(message, options);
    } else {
      console.warn("Snackbar ref not set! Message:", message);
    }
  },
};
